import { Link } from 'react-router-dom';

export default function ComparisonSection() {
  const rows = [
    { feature: 'Product Discovery', vigorbuy: true, traditional: false },
    { feature: 'Seller Research', vigorbuy: true, traditional: false },
    { feature: 'Buying Guides', vigorbuy: true, traditional: false },
    { feature: 'Product Categories', vigorbuy: true, traditional: false },
    { feature: 'Price Comparison', vigorbuy: true, traditional: false },
    { feature: 'Daily Updates', vigorbuy: true, traditional: false },
  ];

  return (
    <section id="comparison" className="bg-background-100 py-16 md:py-24">
      <div className="px-6 md:px-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 border border-accent-200 rounded-full whitespace-nowrap">
              Comparison
            </span>
            <h2 className="mt-4 text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              VigorBuy vs Traditional Search
            </h2>
            <p className="mt-3 text-base text-foreground-600 max-w-lg mx-auto leading-relaxed">
              See why thousands of buyers trust the VigorBuy Spreadsheet over manual searching.
            </p>
          </div>

          {/* Table */}
          <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70">
            {/* Header */}
            <div className="grid grid-cols-3 bg-background-100 px-6 py-4 border-b border-background-200/70">
              <div className="text-sm font-semibold text-foreground-700">Feature</div>
              <div className="text-sm font-semibold text-primary-700 text-center">VigorBuy</div>
              <div className="text-sm font-semibold text-foreground-500 text-center">Traditional Search</div>
            </div>
            {/* Rows */}
            {rows.map((row, i) => (
              <div
                key={row.feature}
                className={`grid grid-cols-3 px-6 py-4 ${i < rows.length - 1 ? 'border-b border-background-200/50' : ''}`}
              >
                <div className="text-sm text-foreground-800 font-medium">{row.feature}</div>
                <div className="text-center">
                  {row.vigorbuy ? (
                    <span className="w-6 h-6 inline-flex items-center justify-center">
                      <i className="ri-check-line text-lg text-primary-600"></i>
                    </span>
                  ) : (
                    <span className="w-6 h-6 inline-flex items-center justify-center">
                      <i className="ri-close-line text-lg text-foreground-300"></i>
                    </span>
                  )}
                </div>
                <div className="text-center">
                  {row.traditional ? (
                    <span className="w-6 h-6 inline-flex items-center justify-center">
                      <i className="ri-check-line text-lg text-primary-600"></i>
                    </span>
                  ) : (
                    <span className="text-xs text-foreground-400">Slow</span>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <Link
              to="/article/vigorbuy-vs-pandabuy-comparison"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              Read Full Comparison: VigorBuy vs Pandabuy <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}